import React, { useEffect, useState } from 'react';
import Modal from "antd/es/modal";
import { GeoJSON, Map, Marker, Popup, TileLayer } from "react-leaflet";
import { Icon } from "leaflet";
import "./mapStyle.css";
import "leaflet/dist/leaflet.css";

import { geojsonIndia } from '../../util/methods';
import { getLeafletTileConfig } from '../../util/mapTiles';

const geojson = geojsonIndia

function MapView(props) {
  const { isVisible, hideVisible, data } = props;
  const tileLayerConfig = getLeafletTileConfig();
  const [latitude, setLatitude] = useState(0)
  const [longitude, setLongitude] = useState(0)
  const [assetCode, setAssetCode] = useState('')

  useEffect(() => {
    if (data && data['code']) {
      setLatitude(data && data['latitude']);
      setLongitude(data && data['longitude']);
      setAssetCode(data && data['asset'] && data['asset'].assetCode);
    } else if (data && data['pvAppNo']) {
      setLatitude(data && data['pv'] && data['pv']['latitude']);
      setLongitude(data && data['pv'] && data['pv']['longitude']);
      setAssetCode(data && data['asset'] && data['asset'].assetCode)
    } else if (data && (data['astNo'] || data['acvNo'])) {
      setLatitude(data && data['assetDetails'] && data['assetDetails'][0] && data['assetDetails'][0]['latitude']);
      setLongitude(data && data['assetDetails'] && data['assetDetails'][0] && data['assetDetails'][0]['longitude']);
      setAssetCode(data && data['assetDetails'] && data['assetDetails'][0].assetCode)
    }
  }, [data, isVisible]);

  const markerIcon = new Icon({
    iconUrl:
      "https://cdn4.iconfinder.com/data/icons/twitter-29/512/157_Twitter_Location_Map-512.png",
    iconSize: [35, 35]
  });

  return (
    <div style={{ height: '50vh', width: '90vw' }}>
      <Modal
        style={{ height: '45vh', width: '80vw' }}
        // bodyStyle={{height: '45vh', width: '90vw'}}
        title={null}
        centered
        visible={!!(isVisible && latitude && longitude)}
        onCancel={() => hideVisible()}
        footer={null}
      >
        <Map center={[latitude, longitude]} zoom={10} attributionControl={false}>
          <TileLayer
            attribution=''
            maxZoom={20}
            url={tileLayerConfig.url}
            subdomains={tileLayerConfig.subdomains}
          />
          <GeoJSON data={geojson} style={{ color: 'grey', weight: 1 }} />
          {(<Marker position={[latitude, longitude]} icon={markerIcon}>
            <Popup>
              <h2>{assetCode} </h2>
            </Popup>
          </Marker>
          )}
        </Map>
        {latitude}  {longitude}
      </Modal>
    </div>
  );
}

export default MapView;
